module.exports = __webpack_public_path__ + "img/Differentiation-INCA_10X_IC.dd429210.png";